import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const Footer = () => {
    useEffect(() => {}, []);
    const { t } = useTranslation();

    return (
        <footer className="footer-wrapper">
            <div className="inner">
                <h2 className="ft_logo">Nurion</h2>
                <ul className="ft_menu">
                    <li>
                        <Link to="/service">{t('이용약관')}</Link>
                    </li>
                    <li className="policy">
                        <Link to="/policy">{t('개인정보처리방침')}</Link>
                    </li>
                </ul>
                <address className="t_addr">{t('경기도 안산시 상록구 팔곡두레길 111')}</address>
                <address className="b_addr">
                    <span>{t('(주)누리온')}</span>
                    <span>{'T. +82-1877-7722'}</span>
                    <span>{t('E. info@nuri-on.com')}</span>
                    <span>© Nurion.</span>
                </address>
            </div>
        </footer>
    );
};

export default Footer;
